<template>
    <div
        v-if="currentMessageBoxData"
        class="wrapper"
    >
        <div class="mask"></div>
        <div class="dialog">
            <div class="title">
                {{ currentMessageBoxData.title }}
                <div class="date">
                    {{ $tools.formatTime(+currentMessageBoxData.sendTime, 'MM月DD日 HH:mm') }}
                </div>
            </div>
            <ResearchQuestion
                v-if="isResearchType"
                ref="researchQuestionRef"
                :data="questionData"
            />
            <pdf-viewer
                v-else-if="isLetterConfirmType && currentMessageBoxData.displayPdfPcUrl"
                :url="currentMessageBoxData.displayPdfPcUrl"
                class="pdf-content"
            />
            <pc-preview
                v-else-if="currentMessageBoxData.announcement"
                :text="currentMessageBoxData.announcement"
            />
            <div class="button-container">
                <el-button
                    v-for="(item, index) in buttonList"
                    :key="index"
                    :disabled="disabled"
                    :class="['message-button']"
                    :type="buttonPrimaryList.includes(item.actionCode) ? 'primary' : ''"
                    size="medium"
                    @click="buttonFunction(item.actionCode)"
                >
                    {{ item.title + (time > 0 ? `(${time})` : '') }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { reportModuleView, reportModuleClick } from 'utils/reportLxHelper';
import PdfViewer from 'components/PdfViewer';
import PcPreview from './PcPreview';
import ResearchQuestion from './ResearchQuestion';

const INFO_TYPE_MAP = {
    /** 通知类 */
    INFORM: 1,
    /** 规则类 */
    RULES: 2,
    /** 函件类 */
    LETTER: 3,
    /** 调研类 */
    RESEARCH: 4,
    /** 函件确认类 */
    LETTER_CONFIRM: 5,
};
const ACTION_CODE_MAP = {
    /** 通知类：11- 确认 */
    INFORM_CONFIRM: 11,
    /** 规则类：21-确认规则 */
    RULES_CONFIRM: 21,
    /** 规则类：22-稍后确认 */
    RULES_LATER_CONFIRM: 22,
    /** 函件类：31-申诉 */
    CORRESPONDENCE_APPEAL: 31,
    /** 函件类：32-签署 */
    CORRESPONDENCE_SIGN: 32,
    /** 函件确认类：51-确认函件 */
    LETTER_CONFIRM: 51,
    /** 调研类：41-提交 */
    RESEARCH_SUBMIT: 41,
};
export default {
    name: 'XxNoticeDialog',
    inject: {
        refreshNoticeBar: { default: () => () => {} },
    },
    components: {
        PcPreview,
        ResearchQuestion,
        PdfViewer,
    },
    data() {
        return {
            noticeList: [],
            time: 0,
            disabled: true,
            currentMessageBoxData: null,
            buttonList: [],
            buttonPrimaryList: [ACTION_CODE_MAP.INFORM_CONFIRM, ACTION_CODE_MAP.RULES_CONFIRM, ACTION_CODE_MAP.CORRESPONDENCE_SIGN, ACTION_CODE_MAP.LETTER_CONFIRM, ACTION_CODE_MAP.RESEARCH_SUBMIT],
            isResearchType: false,
            isLetterConfirmType: false,
            questionData: {
                mcQuestionDTO: [],
                assayQuestionDTO: [],
            },
            dialogEnterTime: 0, // 弹窗展示时间
        };
    },
    async mounted() {
        await this.getAlert();
        if (this.noticeList && this.noticeList.length > 0) {
            this.renderMessageBox(this.noticeList.shift());
        }
    },
    methods: {
        reportDialogStayDuration() {
            // 计算停留时长（秒）
            const stayDuration = Math.floor((Date.now() - this.dialogEnterTime) / 1000);
            reportModuleClick(this, 'b_chaoshi_6cbu8r6f_mc', {
                duration_time: stayDuration, // 停留时长（秒）
            });
        },
        async submitQuestionAnswers() {
            if (!this.$refs.researchQuestionRef) return;
            const isValidate = await this.$refs.researchQuestionRef.validate();
            if (!isValidate) return;
            const params = {
                ...this.$refs.researchQuestionRef.getData(),
                announcementId: this.currentMessageBoxData.id,
            };
            await this.$hPost('/api/vss/shepherd/announcement/commitAnswer', params);
            this.$message.success('提交成功');
            this.refreshNoticeBar();
            this.renderMessageBox(this.noticeList.shift());
        },
        buttonFunction(actionCode) {
            // 上报停留时长
            this.reportDialogStayDuration();

            if ([ACTION_CODE_MAP.RESEARCH_SUBMIT].includes(actionCode)) {
                this.submitQuestionAnswers();
            } else if ([ACTION_CODE_MAP.INFORM_CONFIRM, ACTION_CODE_MAP.RULES_CONFIRM, ACTION_CODE_MAP.LETTER_CONFIRM].includes(actionCode)) {
                this.confirm();
            } else if ([ACTION_CODE_MAP.CORRESPONDENCE_SIGN].includes(actionCode)) {
                this.$tools.linkTo('/content/punishment/detail.html', { ticketId: this.currentMessageBoxData.callbackParams.ticketId, mode: 'edit' });
            } else {
                this.renderMessageBox(this.noticeList.shift());
            }
        },
        handleQuestionData(data) {
            const { mcQuestionDTO = [], assayQuestionDTO = [] } = data || {};
            if (mcQuestionDTO && mcQuestionDTO.length > 0) {
                this.questionData.mcQuestionDTO = mcQuestionDTO;
            }
            if (assayQuestionDTO && assayQuestionDTO.length) {
                this.questionData.assayQuestionDTO = assayQuestionDTO;
            }
        },
        renderMessageBox(data) {
            /**
             * 把弹窗数据给它，当数据为空就结束了。
             */
            this.currentMessageBoxData = data;
            if (!this.currentMessageBoxData) return;

            // 记录弹窗展示时间
            this.dialogEnterTime = Date.now();
            this.$nextTick(() => {
                reportModuleView(this, 'b_chaoshi_2a147crp_mv');
            });
            this.isResearchType = data.infoType === INFO_TYPE_MAP.RESEARCH;
            this.isLetterConfirmType = data.infoType === INFO_TYPE_MAP.LETTER_CONFIRM;
            this.time = this.isResearchType ? '' : this.currentMessageBoxData.forceDuration;
            this.disabled = !this.isResearchType;
            this.buttonList = this.currentMessageBoxData.buttonList;
            if (this.isResearchType) {
                this.handleQuestionData(data);
            } else {
                const timer = setInterval(() => {
                    this.time -= 1;
                    if (this.time < 1) {
                        clearInterval(timer);
                        this.disabled = false;
                    }
                }, 1000);
            }
        },
        async getAlert() {
            const { announcementInfoList } = await this.$hPost('/api/vss/shepherd/announcement/queryVssForce', {
                paging: {
                    offset: 0,
                    limit: 3,
                },
            });
            this.noticeList = announcementInfoList || [];
        },
        async confirm() {
            if (this.disabled) return;
            try {
                await this.$hPost('/api/vss/shepherd/announcement/detail', {
                    id: this.currentMessageBoxData.id,
                    userEnsure: true,
                });
                this.refreshNoticeBar();
                this.renderMessageBox(this.noticeList.shift());
            } catch {
                this.$message.error('网络异常');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.message-button:not(:first-child) {
    margin-left: 20px;
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    opacity: 0.7;
    background: #000000;
}
.dialog {
    position: fixed;
    width: 70%;
    max-width: 1000px;
    min-width: 620px;
    max-height: 650px;
    overflow-y: auto;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    background: #fff;
    z-index: 1001;
    padding: 40px 30px 30px 30px;
    box-shadow: 0px 0px 13px 4px #0000004d;
    border-radius: 8px;
    .title {
        font-size: 20px;
        color: #ef5f5f;
        text-align: center;
        padding: 20px;
        word-wrap: break-word;
        word-break: break-all;
        .date {
            font-size: 12px;
            text-align: center;
            color: #a2a4b3;
            margin-top: 10px;
        }
    }
    .announcement {
        padding: 0 30px;
        line-height: 30px;
        word-wrap: break-word;
        word-break: break-all;
    }
    .pdf-content {
        height: 400px;
        overflow-y: auto;
        margin: 10px 0;
    }
    .button-container {
        text-align: center;
        margin-top: 30px;
    }
    .confirm {
        width: 150px;
        height: 36px;
        line-height: 36px;
        background: #15cdb0;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        border: none;
        outline: none;
        cursor: pointer;
        &.disabled {
            background: #a2a4b3;
        }
    }
    /deep/ .quillWrapper .ql-snow.ql-toolbar {
        display: none;
    }
    .ql-container.ql-snow {
        border: 0px;
    }
}
</style>
